/* eslint-disable no-case-declarations */
import axios from "axios";
import router from "@/router";
import {
  Message
} from 'element-ui'
import {
    getToken
  } from '@/utils/auth'
import store from '@/store'
// 环境的切换


if (process.env.NODE_ENV == "development") {
  axios.defaults.baseURL = `${process.env.VUE_APP_BASE_API}`;
} else {
  const origin = window.origin;
  axios.defaults.baseURL = `${origin}${process.env.VUE_APP_BASE_API}`;
}

// http/index.ts
//创建axios的一个实例
const instance = axios.create({
  timeout: 30000, //设置超时
});
//请求拦截器
instance.interceptors.request.use(
  (config) => {
    if (store.getters.token) {
      config.headers['X-Token'] = getToken()
    }
    // console.log(config, "config");
    
    removePending(config);
    addPending(config);
    return config;
  },
  (error) =>
    // 对请求错误做些什么
    Promise.reject(error)
);

//响应拦截器
instance.interceptors.response.use(
  //响应成功
  (response) => {
    const res = response.data
    if (res.code == 4001) {
        Message({
          message: res.message || '当前账号未登录！请登录',
          type: 'error',
          duration: 5 * 1000
        })
        router.push('login')
      }
      if (res.code > 200) {
        Message({
          message: res.message || res.msg || '服务器响应失败!!请联系管理员',
          type: 'error',
          duration: 5 * 1000
        })
      }
      removePending(response.config);
      return response.data
  },
  //响应失败
  (error) => {
    if(error.name != "CanceledError"){
      Message({
        message: '服务器响应失败！！，请联系管理员',
        type: 'error',
        duration: 5 * 1000
      })
    }
    
      console.log(error);
      
    error.config && removePending(error.config);
    return Promise.reject(error.response.data);
  }
);
//
const pendingMap = new Map();

/**
 * 生成每个请求唯一的键
 * @param {*} config
 * @returns string
 */
function getPendingKey(config) {
  const { url, method, params } = config;
  let { data } = config;
  if (typeof data === "string") data = JSON.parse(data); // response里面返回的config.data是个字符串对象
  return [url, method, JSON.stringify(params), JSON.stringify(data)].join("&");
}

/**
 * 储存每个请求唯一值, 也就是cancel()方法, 用于取消请求
 * @param {*} config
 */
function addPending(config) {
  const pendingKey = getPendingKey(config);
  config.cancelToken =
    config.cancelToken ||
    new axios.CancelToken((cancel) => {
      if (!pendingMap.has(pendingKey)) {
        pendingMap.set(pendingKey, cancel);
      }
    });
}

/**
 * 删除重复的请求
 * @param {*} config
 */
function removePending(config) {
  const pendingKey = getPendingKey(config);
  if (pendingMap.has(pendingKey)) {
    const cancelToken = pendingMap.get(pendingKey);
    cancelToken(pendingKey);
    pendingMap.delete(pendingKey);
  }
}
export default instance;
